import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Logo from "../assets/logo.png";

const WEB_APP_URL = "https://hynt.co.in/app";

function RevampNavbar({ color }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const onProfessionals =
    pathname === "/professionals" || pathname.startsWith("/professionals/");

  const closeMenu = () => setMenuOpen(false);

  const onNavClick = () => () => {
    closeMenu();
  };

  return (
    <header className={`revamp-navbar-wrap ${menuOpen ? "is-expanded" : ""}`}>
      <nav className="revamp-navbar">
        {color ? (
          <Link to="/" className="revamp-logo-link" onClick={onNavClick("Logo", "/")}>
            <img src={Logo} alt="HYNT logo" className="revamp-logo-white" />
          </Link>
        ) : (
          <Link to="/" className="revamp-logo-link" onClick={onNavClick("Logo", "/")}>
            <img src={Logo} alt="HYNT logo" className="revamp-logo" />
          </Link>
        )}
        {/* <Link to="/" className="revamp-logo-link" onClick={closeMenu}>
          <img src={Logo} alt="HYNT logo" className="revamp-logo" />
        </Link> */}

        <button
          type="button"
          className="revamp-mobile-toggle"
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          aria-controls="revamp-main-menu"
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </button>

        <div id="revamp-main-menu" className={`revamp-nav-links ${menuOpen ? "open" : ""}`}>
          {/* <NavLink
            to="/create-business"
            end
            className={({ isActive }) =>
              `revamp-primary-nav-btn revamp-list-business-btn ${isActive ? "is-active" : ""}`.trim()
            }
            onClick={closeMenu}
          >
            List your business
          </NavLink> */}
          <NavLink
            to={onProfessionals ? "/" : "/professionals"}
            end
            className={({ isActive }) => `revamp-nav-link ${isActive ? "is-active" : ""}`.trim()}
            onClick={onNavClick(
              onProfessionals ? "For Homeowners" : "For Professionals",
              onProfessionals ? "/" : "/professionals",
            )}
          >
            {onProfessionals ? "For Homeowners" : "For Professionals"}
          </NavLink>
          <NavLink
            to="/careers"
            end
            className={({ isActive }) => `revamp-nav-link ${isActive ? "is-active" : ""}`.trim()}
            onClick={onNavClick("Careers", "/careers")}
          >
            Careers
          </NavLink>
          <NavLink
            to="/contact"
            end
            className={({ isActive }) => `revamp-nav-link ${isActive ? "is-active" : ""}`.trim()}
            onClick={onNavClick("Contact Us", "/contact")}
          >
            Contact Us
          </NavLink>
          <a
            href={WEB_APP_URL}
            className="revamp-primary-nav-btn"
            onClick={closeMenu}
          >
            Login / Sign up
          </a>
        </div>
      </nav>
    </header>
  );
}

export default RevampNavbar;
